import type { SVGProps } from 'react';
import { IconBase } from './icon-base';

export function ArrowUpRightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props} strokeWidth="1.5">
      <path d="M7 7h10v10" />
      <path d="M7 17 17 7" />
    </IconBase>
  );
}
